import React, { useState, useEffect } from "react";
import PersonalInfo from "./Personal Info/PersonalInfo";
import SalaryInfo from "./Salary Info/SalaryInfo";
import Documents from "./documents Info/Documents";
import ManagerInfo from "./Manager Info/ManagerInfo";
import RequestedChanges from "./Requested Changes/RequestedChanges";
import EmployeeLeaves from "./Employee Leaves/EmployeeLeaves";
import ProfileSidebar from "./ProfileSidebar";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, Dialog, DialogTitle, DialogActions, CircularProgress } from "@mui/material";

import "./personalDetails.css";

const PersonalDetails = (props) => {
  const user = props.user;
  const [showPersonal, setShowPersonal] = useState(true);
  const [showSalary, setShowSalary] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [showManager, setshowManager] = useState(false);
  const [showRequestedChanges, setshowRequestedChanges] = useState(false);
  const [showLeaves, setShowLeaves] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadbtnshow, setuploadbtnshow] = useState(false);
  const [loader, showLoader] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [openD, setOpenD] = useState(false);

  const Employee = props.Employee;

  useEffect(() => {
    // Wait until Employee.profilepic is available before loading
    if (Employee && Employee.profilepic) {
      setIsImageLoading(false);
    }
  }, [Employee]);

  const handleImageLoad = () => {
    setIsImageLoading(false); // Image finished loading
  };

  const handleProfilePictureUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setuploadbtnshow(true);
      setSelectedFile(file);
      const objectURL = URL.createObjectURL(file);
      setProfilePicture(objectURL);
    }
  };

  const handleUploadPhoto = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("photo", selectedFile);
    formData.append("email", Employee.email);
    formData.append("name", Employee.name);
    formData.append("field", "profilepic");
    showLoader(true);
    setuploadbtnshow(false);

    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/uploadphoto", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok && data.success) {
        showLoader(false);
        // console.log('Photo uploaded successfully:', data);
      } else {
        setuploadbtnshow(true);
        // console.error('Photo upload failed:', data.message);
      }
    } catch (error) {
      setuploadbtnshow(true);
      // console.error('Error uploading photo:', error);
    }
  };

  const handleShowPersonalD = () => {
    setShowPersonal(true);
    setShowSalary(false);
    setShowDocuments(false);
    setshowManager(false);
    setshowRequestedChanges(false);
    setShowLeaves(false);
  };
  const handleShowSalaryInfo = () => {
    setShowPersonal(false);
    setShowSalary(true);
    setShowDocuments(false);
    setshowManager(false);
    setshowRequestedChanges(false);
    setShowLeaves(false);
  };
  const handleShowDocuments = () => {
    setShowPersonal(false);
    setShowSalary(false);
    setShowDocuments(true);
    setshowManager(false);
    setshowRequestedChanges(false);
    setShowLeaves(false);
  };
  const handleShowManager = () => {
    setShowPersonal(false);
    setShowSalary(false);
    setShowDocuments(false);
    setshowManager(true);
    setshowRequestedChanges(false);
    setShowLeaves(false);
  };
  const handleShowRequests = () => {
    setShowPersonal(false);
    setShowSalary(false);
    setShowDocuments(false);
    setshowManager(false);
    setshowRequestedChanges(true);
    setShowLeaves(false);
  };
  const handleShowLeaves = () => {
    setShowPersonal(false);
    setShowSalary(false);
    setShowDocuments(false);
    setshowManager(false);
    setshowRequestedChanges(false);
    setShowLeaves(true);
  };

  const removeEmployee = async (email) => {
    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/remove-employee", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        alert("Employee removed successfully !");
        setTimeout(() => window.location.reload(), 3000);
      } else {
        alert("Failed to remove employee...");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const isHrOrExec = user.role === "HR" || user.role === "Executive";

  return (
    <div className="profileShell">
      <ProfileSidebar
        Employee={Employee}
        user={user}
        showPersonal={showPersonal}
        showSalary={showSalary}
        showDocuments={showDocuments}
        showManager={showManager}
        showRequestedChanges={showRequestedChanges}
        showLeaves={showLeaves}
        onPersonal={handleShowPersonalD}
        onSalary={handleShowSalaryInfo}
        onDocuments={handleShowDocuments}
        onManager={handleShowManager}
        onRequested={handleShowRequests}
        onLeaves={handleShowLeaves}
        isImageLoading={isImageLoading}
        profilePicture={profilePicture}
        uploadbtnshow={uploadbtnshow}
        loader={loader}
        onFileChange={handleProfilePictureUpload}
        onUpload={handleUploadPhoto}
        onImageLoad={handleImageLoad}
      />

      <div className="profileContent">
        {isHrOrExec && (
          <div className="profileBackRow">
            <Button
              className="backButton"
              sx={{ border: "2px solid" }}
              onClick={props.handleDontShowProfile}
            >
              <ArrowBackIosNewIcon />
            </Button>
          </div>
        )}

        {showPersonal && (
          <div className="personalInfo">
            <PersonalInfo
              user={props.user}
              Employee={props.Employee}
              inputEditHandler={props.inputEditHandler}
            />
          </div>
        )}

        {showSalary && (
          <div className="SalaryInfo">
            <SalaryInfo
              user={props.user}
              Employee={props.Employee}
              inputEditHandler={props.inputEditHandler}
            />
          </div>
        )}
        {showDocuments && (
          <div className="documents">
            <Documents user={props.user} Employee={props.Employee} />
          </div>
        )}
        {showManager && (
          <div className="manager">
            {/* Mount only once the profile has loaded: ManagerInfo fetches the team and
                reports on mount, so mounting it with a null Employee left the tab empty. */}
            {props.Employee ? (
              <ManagerInfo user={props.user} Employee={props.Employee} />
            ) : (
              <div className="mgrOtState">
                <CircularProgress size={22} />
              </div>
            )}
          </div>
        )}
        {showRequestedChanges && (
          <div className="requestedchanges">
            <RequestedChanges user={props.user} Employee={props.Employee} />
          </div>
        )}
        {showLeaves && (
          <div className="leavesInfo">
            <EmployeeLeaves user={props.user} Employee={props.Employee} />
          </div>
        )}

        {isHrOrExec && Employee && Employee.manager == "no" && (
          <div className="profileRemoveBlock">
            <hr />
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpenD(true)}
            >
              Remove Employee
            </Button>

            <Dialog open={openD} onClose={() => setOpenD(false)}>
              <DialogTitle>
                Are you sure you want to remove this employee?
              </DialogTitle>
              <DialogActions>
                <Button onClick={() => setOpenD(false)} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    removeEmployee(Employee.email);
                    setOpenD(false);
                  }}
                  color="error"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalDetails;
